import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { ShadowBoxDark } from 'app/components';
import { textTransform } from 'utils';

export const Box = styled(ShadowBoxDark)`
  padding: ${({ theme }) => `${theme.indent.m} ${theme.indent.m} 18px`};

  & ~ & {
    margin-top: ${({ theme }) => theme.indent.m};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    & ~ & {
      margin-top: ${({ theme }) => theme.indent.l};
    }
  }
`;

export const Title = styled.p`
  position: relative;
  display: flex;

  & > button {
    margin-right: 4px;
  }
`;

export const TitleLink = styled(NavLink)`
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.44;
  letter-spacing: 1.5px;
  text-transform: ${textTransform};
  color: ${({ theme }) => theme.color.accent};
  transition: color 0.2s ease-out;
  backface-visibility: hidden;

  &:hover {
    color: ${({ theme }) => theme.color.textPrimary};
  }
`;

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: ${({ theme }) => `0 -${theme.indent.s}`};
`;

export const ListItem = styled.li`
  width: 33.33%;
  padding: ${({ theme }) => theme.indent.m} ${({ theme }) => theme.indent.s} 6px;

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    width: 50%;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.xs.width}) {
    width: 100%;
  }
`;

export const ListItemLink = styled(NavLink)`
  width: 100%;
  height: 100%;
  padding: ${({ theme }) => theme.indent.s} ${({ theme }) => theme.indent.m};
  border: 1px solid ${({ theme }) => theme.color.rgbaWhite('.3')};
  border-radius: 24px;
  text-align: center;
  transition: background-color 0.2s ease-out, border-color 0.2s ease-out;

  &:hover {
    border-color: ${({ theme }) => theme.color.rgbaWhite('.02')};
    background-color: ${({ theme }) => theme.color.rgbaWhite('.08')};
  }
`;

export const NoDays = styled.p`
  margin-top: 4px;
  color: ${({ theme }) => theme.color.labelColor};
  font-size: 1.7rem;
`;

export const Panel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 44px;
  margin: ${({ theme }) => `${theme.indent.m} -${theme.indent.m} -${theme.indent.m}`};
  padding: ${({ theme }) => `0 ${theme.indent.m}`};
  border-top: ${({ theme }) => theme.color.bgSecondary} solid 1px;
  text-transform: ${textTransform};
  font-size: 1.4rem;
  font-weight: 500;

  button {
    position: absolute;
    right: ${({ theme }) => theme.indent.m};
  }
`;
